import { render, staticRenderFns } from "./FallbackCascade.vue?vue&type=template&id=64ed0b3e&"
import script from "./FallbackCascade.vue?vue&type=script&lang=js&"
export * from "./FallbackCascade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports